// extracted by mini-css-extract-plugin
export var content = "_vo-1";
export var wrapper = "_vo-0";